function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "title-logo4"
}, "Procesna oprema Bitenc");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", {
  id: "desc-logo4"
}, "sita, drobilci, su\u0161ilci, me\u0161alci");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.92,17.61a112.59,112.59,0,0,0-72.67,141.6,110,110,0,0,0,5.22,13.23l-8.43,4a123.57,123.57,0,0,1-5.64-14.35,122.13,122.13,0,0,1,157-152.32L325,17.09s-.08,0-.18,0a99.43,99.43,0,0,0-10.48-2.7A112.72,112.72,0,0,0,256.92,17.61Z",
  transform: "translate(0 -2.69)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M364.29,26.78,244.94,146.13l-6.61-6.57L346.77,31.16l2.89-2.93,6.8-6.71c1.07.7,2.14,1.4,3.17,2.1Z",
  transform: "translate(0 -2.69)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M239.31,224.52l.23.14-6.89,6.85c-1.12-.61-2.24-1.26-3.36-1.91l-5.17-3.08L345.51,105.83l6.57,6.62Z",
  transform: "translate(0 -2.69)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M328.75,240.82A121.87,121.87,0,0,1,258,242l7.63-7.65.47.14c3.68.84,7.41,1.49,11.18,2A112.55,112.55,0,0,0,398.57,90.27l8.9-2.84C428,151.39,392.7,220.24,328.75,240.82Z",
  transform: "translate(0 -2.69)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "395.07 110.02 386.93 105.49 401.17 79.89 426.63 93.5 422.25 101.72 404.85 92.42 395.07 110.02"
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "187.39 180.74 161.92 167.13 166.32 158.91 183.69 168.2 193.48 150.61 201.62 155.14 187.39 180.74"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 230.42,
  y: 46.74,
  width: 107.31,
  height: 9.32,
  transform: "translate(46.68 212.98) rotate(-44.94)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 252.36,
  y: 199.2,
  width: 100.62,
  height: 9.31,
  transform: "translate(-55.48 271.1) rotate(-45.01)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M207.87,205.65a9.32,9.32,0,1,1-9.32-9.32A9.32,9.32,0,0,1,207.87,205.65Z",
  transform: "translate(0 -2.69)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M401.62,59.31A9.32,9.32,0,1,1,392.3,50,9.32,9.32,0,0,1,401.62,59.31Z",
  transform: "translate(0 -2.69)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M251.35,152.34a13.59,13.59,0,1,1-.23-19.23A13.6,13.6,0,0,1,251.35,152.34Z",
  transform: "translate(0 -2.69)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.1,86a10.67,10.67,0,1,1-13.43-6.89A10.68,10.68,0,0,1,256.1,86Z",
  transform: "translate(0 -2.69)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M361.73,105a13.59,13.59,0,1,1-17.09-8.78A13.61,13.61,0,0,1,361.73,105Z",
  transform: "translate(0 -2.69)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M349.83,163.84a10.68,10.68,0,1,1-13.44-6.9A10.67,10.67,0,0,1,349.83,163.84Z",
  transform: "translate(0 -2.69)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.44,284.26c0,7.74-5.72,12.51-15,12.51H6.53v10.15H0V271.75H14.47C23.72,271.75,29.44,276.47,29.44,284.26Zm-6.58,0c0-4.42-3-7-8.69-7H6.53v14h7.64C19.9,291.25,22.86,288.68,22.86,284.26Z",
  transform: "translate(0 -2.69)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.26,306.92l-7.19-10.3a12.18,12.18,0,0,1-1.35.05H46.78v10.25H40.25V271.75H54.72c9.24,0,15,4.72,15,12.51a11.24,11.24,0,0,1-7.49,11.11l8.09,11.55Zm-8.85-29.64H46.78v14h7.63c5.73,0,8.7-2.62,8.7-7S60.14,277.28,54.41,277.28Z",
  transform: "translate(0 -2.69)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.23,289.34c0-10.4,8-18.09,18.94-18.09s19,7.64,19,18.09-8,18.09-19,18.09S78.23,299.74,78.23,289.34Zm31.3,0A12.36,12.36,0,1,0,97.17,301.7,12,12,0,0,0,109.53,289.34Z",
  transform: "translate(0 -2.69)"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.3,289.34c0-10.5,8-18.09,18.85-18.09,5.72,0,10.65,2.06,13.91,5.88l-4.22,4a12.31,12.31,0,0,0-9.39-4.12c-7.29,0-12.57,5.12-12.57,12.36s5.28,12.36,12.57,12.36a12.22,12.22,0,0,0,9.39-4.17l4.22,4c-3.26,3.82-8.19,5.88-14,5.88C132.34,307.43,124.3,299.84,124.3,289.34Z",
  transform: "translate(0 -2.69)"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.49,301.45v5.47H167.11V271.75h25.68v5.48H173.64v9.14h17v5.38h-17v9.7Z",
  transform: "translate(0 -2.69)"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201.58,303.21l2.26-5.08A19.48,19.48,0,0,0,215.45,302c5.47,0,7.78-2,7.78-4.57,0-7.59-20.9-2.62-20.9-15.68,0-5.68,4.52-10.5,14.17-10.5a22.26,22.26,0,0,1,11.71,3.11l-2.06,5.08a19.54,19.54,0,0,0-9.7-2.76c-5.43,0-7.64,2.11-7.64,4.77,0,7.49,20.86,2.61,20.86,15.52,0,5.63-4.58,10.46-14.22,10.46C210,307.43,204.49,305.72,201.58,303.21Z",
  transform: "translate(0 -2.69)"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M271.17,271.75v35.17h-5.38L246.4,283.11v23.81h-6.49V271.75h5.38l19.4,23.82V271.75Z",
  transform: "translate(0 -2.69)"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M307.19,298.78H289.61l-3.47,8.14h-6.73l15.82-35.17h6.43l15.88,35.17h-6.83ZM305,293.66l-6.63-15.38-6.58,15.38Z",
  transform: "translate(0 -2.69)"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M341.46,289.34c0-10.2,7.78-17.84,18.29-17.84S378,279.09,378,289.34s-7.84,17.84-18.29,17.84S341.46,299.54,341.46,289.34Zm34,0c0-8.9-6.73-15.48-15.67-15.48S344,280.44,344,289.34s6.73,15.47,15.73,15.47S375.42,298.23,375.42,289.34Z",
  transform: "translate(0 -2.69)"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M417.48,283.61c0,7.39-5.33,11.81-14.17,11.81H393.26v11.5h-2.57V271.75h12.62C412.15,271.75,417.48,276.17,417.48,283.61Zm-2.62,0c0-6.08-4-9.55-11.55-9.55H393.26v19.05h10.05C410.84,293.11,414.86,289.64,414.86,283.61Z",
  transform: "translate(0 -2.69)"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M454.81,306.92l-8.39-11.75a25,25,0,0,1-3.42.25H433v11.5h-2.56V271.75H443c8.84,0,14.17,4.42,14.17,11.86,0,5.58-3,9.45-8.24,11l8.79,12.31ZM443,293.16c7.54,0,11.56-3.52,11.56-9.55s-4-9.55-11.56-9.55H433v19.1Z",
  transform: "translate(0 -2.69)"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M494.6,304.61v2.31H470.33V271.75h23.52v2.31h-21v13.87h18.74v2.26H472.89v14.42Z",
  transform: "translate(0 -2.69)"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M541,306.92l-.05-30.09L526.2,302.25H525l-14.73-25.32v30h-2.51V271.75h2.16l15.73,27.18,15.73-27.18h2.11l0,35.17Z",
  transform: "translate(0 -2.69)"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M581.27,297h-20.4l-4.47,9.89h-2.77l16.18-35.17h2.57l16.18,35.17h-2.77Zm-.95-2.17-9.25-20.3-9.19,20.3Z",
  transform: "translate(0 -2.69)"
});

var _ref32 =
/*#__PURE__*/
React.createElement("rect", {
  x: 22.62,
  y: 332.63,
  width: 140.62,
  height: 3.83
});

var _ref33 =
/*#__PURE__*/
React.createElement("rect", {
  x: 425.31,
  y: 332.63,
  width: 140.63,
  height: 3.83
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187,324.88h6.46c3,0,5.16.44,6.5,1.31a4.59,4.59,0,0,1,2,4.14,5,5,0,0,1-1,3.17,4.43,4.43,0,0,1-2.83,1.59v.15a5.61,5.61,0,0,1,3.37,1.71,5.12,5.12,0,0,1,1.08,3.44,5.59,5.59,0,0,1-2,4.6,8.83,8.83,0,0,1-5.69,1.66H187Zm3.56,9H194a5.77,5.77,0,0,0,3.26-.71,2.69,2.69,0,0,0,1-2.4,2.42,2.42,0,0,0-1.11-2.22,6.89,6.89,0,0,0-3.52-.68h-3.08Zm0,2.89v6.89h3.78a5.56,5.56,0,0,0,3.37-.85,3.16,3.16,0,0,0,1.14-2.71,2.86,2.86,0,0,0-1.16-2.51,6.13,6.13,0,0,0-3.53-.82Z",
  transform: "translate(0 -2.69)"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M228.47,346.65V324.88H232v21.77Z",
  transform: "translate(0 -2.69)"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M266.64,346.65h-3.56V327.93h-6.4v-3.05H273v3.05h-6.4Z",
  transform: "translate(0 -2.69)"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M310,346.65H297.72V324.88H310v3h-8.76v5.92h8.21v3h-8.21v6.83H310Z",
  transform: "translate(0 -2.69)"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M354.22,346.65h-4.36L339.15,329.3H339l.08,1c.14,1.84.21,3.53.21,5.06v11.32h-3.24V324.88h4.32l10.68,17.25h.09q0-.33-.12-2.49t-.09-3.36v-11.4h3.26Z",
  transform: "translate(0 -2.69)"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M390.57,327.62a5.86,5.86,0,0,0-4.82,2.17,9.3,9.3,0,0,0-1.76,6c0,2.67.57,4.69,1.69,6.06a6,6,0,0,0,4.89,2.06,13,13,0,0,0,2.68-.28c.87-.18,1.76-.42,2.7-.71V346a16.5,16.5,0,0,1-5.81,1c-3.19,0-5.63-1-7.34-2.89s-2.56-4.69-2.56-8.29a13.39,13.39,0,0,1,1.24-5.94,8.85,8.85,0,0,1,3.6-3.9,10.91,10.91,0,0,1,5.52-1.35,13.76,13.76,0,0,1,6.17,1.39l-1.28,3a20.91,20.91,0,0,0-2.33-.92A8.5,8.5,0,0,0,390.57,327.62Z",
  transform: "translate(0 -2.69)"
});

var SvgProcesnaOpremaLogo = function SvgProcesnaOpremaLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": "title-logo4 desc-logo4",
    viewBox: "0 0 588.56 344.25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "title-logo4"
  }, title) : null, _ref3, React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, React.createElement("polygon", {
    points: "250.75 137.62 300.43 87.95 293.85 81.37 244.16 131.04 250.75 137.62",
    style: {
      opacity: 0.54,
      mixBlendMode: "multiply"
    }
  }), React.createElement("polygon", {
    points: "254.39 84.99 304.07 35.32 297.49 28.74 247.8 78.41 254.39 84.99",
    style: {
      opacity: 0.54,
      mixBlendMode: "multiply"
    }
  }), _ref14, _ref15, React.createElement("polygon", {
    points: "337.08 111.46 287.4 161.13 293.99 167.71 343.67 118.04 337.08 111.46",
    style: {
      opacity: 0.54,
      mixBlendMode: "multiply"
    }
  }), React.createElement("polygon", {
    points: "329.84 167.38 280.16 217.06 286.74 223.64 336.43 173.97 329.84 167.38",
    style: {
      opacity: 0.54,
      mixBlendMode: "multiply"
    }
  }), _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProcesnaOpremaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/procesna-oprema-logo.c0f451ee.svg";
export { ForwardRef as ReactComponent };